// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d319efe","455":"17f417a4","977":"a2b4fa8f"}[chunkId] + ".chunk.js";
};